import './BannerHomePhone.css';
import logo from '../../../imgs/logo-eqg-white.svg'
import { motion } from "framer-motion";

function BannerHomePhone() {
    return (
        <div className='container-phones-mobile-home'>
            <motion.div
                animate={{ x: [40, 50, 0], opacity: 1, scale: 1 }}
                transition={{
                    duration: 1,
                    delay: 0.3,
                }}
                initial={{ opacity: 0, scale: 0.5 }}
            >
            <img className='logo2' alt='logo eu quero grana' src={logo} />
            </motion.div>
            
            <div className='textosCabecalho2'>
                <motion.div
                    animate={{ x: [-50, 10, 0], opacity: 1, scale: 1 }}
                >
                <h1>Empréstimo com Débito na conta de Luz</h1>
                </motion.div>
            </div>
        
        </div>
    );
}

export default BannerHomePhone;